<div class="dialog-title">Accessible Domain</div>

<div class="value-container value-f" *ngFor="let domain of result">
  <div class="content-wrapper full single">- {{domain}}</div>
</div>